import Marquee from "react-fast-marquee";

const items = [
  "Azzaro Resorts & Spa",
  "Reimagining Luxury",
  "Diu",
  "Site Under Renewal",
  "Rebuilt In-House",
];

export const Ribbon = () => {
  return (
    <section
      data-testid="editorial-ribbon"
      className="relative border-y border-[#ececec] bg-[#f7f6f2] py-8 sm:py-10"
      aria-hidden="true"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 sm:mx-12">
            <span className="font-display text-2xl font-medium tracking-tight text-[#333333] sm:text-4xl">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#2ca8a0]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default Ribbon;
